var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "12px",
    viewBox: "0 0 10 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "unlock") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "token-swap",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "001-copy",
    transform: "translate(-1125.000000, -596.000000)",
    fill: "#8B93A7",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(360.000000, 393.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(748.000000, 193.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.9857998,21.9973867 L17.9982002,21.9973867 C17.4466421,21.9973867 17,21.5497454 17,20.9976878 L17,15.9986934 C17,15.4466357 17.4471417,14.9984948 17.9982002,14.9984948 L18.4973002,14.9984948 L18.4973002,13.4991962 C18.4973002,11.5667446 20.0620464,10 21.992,10 C23.9219536,10 25.4866998,11.5667446 25.4866998,13.4991962 L25.4866998,14.9984948 L25.9857998,14.9984948 C26.5373579,14.9984948 26.984,15.4461361 26.984,15.9986934 L26.984,20.9976878 C26.984,21.5492458 26.5368583,21.9973867 25.9857998,21.9973867 Z M23.9888999,13.4991962 C23.9888999,12.3950809 23.0946165,11.4997982 21.992,11.4997982 C20.8893835,11.4997982 19.9951001,12.3950809 19.9951001,13.4991962 L19.9951001,14.9984948 L23.9888999,14.9984948 L23.9888999,13.4991962 Z",
    id: "unlock"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.580a7fb0eb98294762a502141163dc4a.svg";
export { ForwardRef as ReactComponent };